(function () {

  function initSlider(root) {

    if (root.dataset.zavaSliderReady === '1') return;

    var track = root.querySelector('[data-zava-slider-track]');

    var prev = root.querySelector('[data-zava-slider-prev]');

    var next = root.querySelector('[data-zava-slider-next]');

    if (!track) return;



    root.dataset.zavaSliderReady = '1';



    function stepSize() {

      var card = track.querySelector('.zava-card, .hph-review, [data-zava-slide]');

      if (!card) return track.clientWidth * 0.8;

      var styles = window.getComputedStyle(track);

      var gap = parseFloat(styles.columnGap || styles.gap) || 12;

      return card.offsetWidth + gap;

    }



    function scrollByDir(dir) {

      track.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });

    }



    function updateArrows() {

      if (!prev || !next) return;

      prev.disabled = track.scrollLeft <= 4;

      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

    }



    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });

    if (next) next.addEventListener('click', function () { scrollByDir(1); });

    track.addEventListener('scroll', updateArrows, { passive: true });

    window.addEventListener('resize', updateArrows, { passive: true });

    updateArrows();

  }



  function initQuickAdd(form) {

    if (form.dataset.zavaQuickReady === '1') return;

    form.dataset.zavaQuickReady = '1';



    form.addEventListener('submit', function (e) {

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');

      if (btn) btn.disabled = true;



      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {

        method: 'POST',

        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: 1 })

      })

        .then(function (r) { return r.json(); })

        .then(function () {

          document.dispatchEvent(new CustomEvent('cart:refresh'));

          document.dispatchEvent(new CustomEvent('cart:updated'));

        })

        .catch(function () {

          form.submit();

        })

        .finally(function () {

          if (btn) btn.disabled = false;

        });

    });

  }



  function boot(scope) {

    var root = scope || document;

    root.querySelectorAll('[data-zava-slider]').forEach(initSlider);

    root.querySelectorAll('[data-zava-quick-add]').forEach(initQuickAdd);

  }



  function initRelated(el) {

    if (!el || el.dataset.zavaRelatedReady === '1') return;

    var url = el.getAttribute('data-url');

    if (!url) {

      el.dataset.zavaRelatedReady = '1';

      boot(el);

      return;

    }



    function load() {

      if (el.dataset.zavaRelatedReady === '1') return;

      el.dataset.zavaRelatedReady = '1';



      fetch(url)

        .then(function (r) { return r.text(); })

        .then(function (html) {

          var doc = new DOMParser().parseFromString(html, 'text/html');

          var incoming = doc.querySelector('[data-zava-related]');

          if (!incoming) {

            el.hidden = true;

            return;

          }



          var content = incoming.querySelector('[data-zava-related-content]');

          var target = el.querySelector('[data-zava-related-content]');

          if (!content || !target) {

            el.hidden = true;

            return;

          }



          if (!content.querySelector('.zava-card')) {

            el.hidden = true;

            return;

          }



          target.innerHTML = content.innerHTML;

          el.classList.remove('zava-related--loading');

          el.classList.add(incoming.classList.contains('zava-related--grid') ? 'zava-related--grid' : 'zava-related--carousel');

          boot(el);

        })

        .catch(function () {

          el.hidden = true;

        });

    }



    if ('IntersectionObserver' in window) {

      var observer = new IntersectionObserver(

        function (entries, obs) {

          if (!entries[0] || !entries[0].isIntersecting) return;

          obs.disconnect();

          load();

        },

        { rootMargin: '0px 0px 220px 0px' }

      );

      observer.observe(el);

    } else {

      load();

    }

  }



  function bootAll(scope) {

    var root = scope || document;

    root.querySelectorAll('[data-zava-related]').forEach(initRelated);

    boot(root);

  }



  window.zavaProductCardBoot = bootAll;



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function () { bootAll(); });

  } else {

    bootAll();

  }



  document.addEventListener('shopify:section:load', function (event) {

    bootAll(event.target);

  });

})();

